export function getSubscription(tenantId) {
  return {
    path: `subscription/${tenantId}`,
    method: 'GET',
  };
}

export function updateSubscription(tenantId, planId, couponId) {
  return {
    path: 'subscription',
    method: 'PUT',
    body: JSON.stringify({
      coupon: couponId || undefined,
      plan: planId || undefined,
      tenant_id: tenantId,
    }),
  };
}

// TODO this should be PUT not GET - it's bad for permission model.
export function reactivateSubscription(tenantId) {
  return {
    path: `subscription/${tenantId}/reactivate`,
    method: 'GET',
  };
}

export function cancelSubscription(tenantId, cancelNow, cancelReason, username) {
  return {
    path: `subscription/${tenantId}`,
    method: 'DELETE',
    body: JSON.stringify({
      cancel_now: cancelNow,
      reason: `reactor: canceled ${cancelNow ? 'immediately' : 'at period end'} by ${username}.\n${cancelReason}`,
    }),
  };
}

export function applyCoupon(tenantId, couponId) {
  return {
    path: 'subscription/coupon/apply',
    body: JSON.stringify({
      coupon: couponId,
      tenant_id: tenantId,
    }),
    method: 'POST',
  };
}

export function getSubscriptionProration(tenantId, plan, coupon) {
  return {
    path: 'subscription/prorate',
    body: JSON.stringify({
      tenant_id: tenantId,
      plan,
      coupon: coupon || null,
    }),
    method: 'POST',
  };
}
